import type { ReactElement } from "react";

import WizardLinkButton from "app/pages/sales-intelligence/sub-modules/onboarding/wizard/components/WizardLinkButton/WizardLinkButton";
import {
    StyledWizardAnimationItem,
    WIZARD_ANIMATION_DELAY,
    WIZARD_ANIMATION_TIME,
} from "app/pages/sales-intelligence/sub-modules/onboarding/wizard/styles";

import WizardGoalCard from "../components/WizardCards/WizardGoalCard";
import WizardContentWrapper from "../components/WizardContentWrapper/WizardContentWrapper";

import { StyledAnimatedWizardGoalCard, StyledWizardGoalCardsContainer } from "./styles";
import type { OnboardingGoalQuestionType } from "app/pages/sales-intelligence/sub-modules/onboarding/types/enums";

interface Props {
    isValid: boolean;
    isLoading?: boolean;
    cardItems: OnboardingGoalQuestionType[];
    activeCard: OnboardingGoalQuestionType | null;
    onCardClick: (cardType: OnboardingGoalQuestionType) => void;
    onNext: () => void;
    onBack: () => void;
    onClose: () => void;
}

const WizardGoalQuestionsContainer = ({
    isValid,
    isLoading,
    cardItems,
    activeCard,
    onCardClick,
    onNext,
    onBack,
    onClose,
}: Props): ReactElement => {
    const list = cardItems.map((cardType: OnboardingGoalQuestionType, index) => (
        <StyledAnimatedWizardGoalCard
            key={cardType}
            delay={(index + 1) * WIZARD_ANIMATION_TIME + WIZARD_ANIMATION_DELAY}
        >
            <WizardGoalCard
                key={cardType}
                type={cardType}
                isActive={activeCard === cardType}
                onClick={() => onCardClick(cardType)}
            />
        </StyledAnimatedWizardGoalCard>
    ));

    return (
        <WizardContentWrapper
            questionTitleKey="si.onboarding.wizard.question2.title"
            questionDescriptionKey="si.onboarding.wizard.question2.description"
            pageCount={2}
            currentPage={2}
            isLoading={isLoading}
            animatedChildren={cardItems.length + 1}
            isNextDisabled={!isValid}
            onNext={onNext}
            onBack={onBack}
        >
            <StyledWizardGoalCardsContainer>
                {list}

                <StyledWizardAnimationItem
                    delay={(cardItems.length + 1) * WIZARD_ANIMATION_TIME + WIZARD_ANIMATION_DELAY}
                >
                    <WizardLinkButton onClick={onClose} />
                </StyledWizardAnimationItem>
            </StyledWizardGoalCardsContainer>
        </WizardContentWrapper>
    );
};

export default WizardGoalQuestionsContainer;
